import "./App.css";
import Products from "./components/Products-index";

function App() {
  return (
    <div className="App">
      <Products />
    </div>
  );
}

export default App;
